<template>
  <b-card>
    <!-- Search Produk Internal -->
    <b-row
      align-h="between"
      no-gutters
      class="w-100"
    >
      <b-col md="5">
        <b-form @submit.prevent="search">
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <img
                src="@/assets/images/icons/barcode-black.svg"
                width="18"
                alt="Icon"
              >
            </b-input-group-prepend>
            <b-form-input
              v-model="keyword"
              type="number"
              size="lg"
              placeholder="Scan barcode atau ketik kode"
            />
          </b-input-group>
        </b-form>
      </b-col>
      <b-col cols="auto">
        <b-form-checkbox
          class="mr-0 mt-50"
          switch
          inline
        />
      </b-col>
      <b-col cols="auto">
        <b-form-row>
          <b-col cols="auto">
            <b-button
              variant="light"
              type="submit"
              form="form-table"
              @click="confirmReset"
            >
              Reset
            </b-button>
          </b-col>
          <b-col cols="auto">
            <b-button
              variant="primary"
              :disabled="loadingSubmit"
              @click.prevent="$refs.formButton.click()"
            >
              <b-spinner
                v-show="loadingSubmit"
                small
              />
              Simpan dan ubah stok
            </b-button>
          </b-col>
        </b-form-row>
      </b-col>
    </b-row>

    <hr v-if="skus.length">
    <div
      v-else
      class="text-center text-muted pt-4 pb-3"
    >
      Harap scan barcode atau ketik code untuk menambahkan SKU
    </div>

    <div class="px-50">
      <b-form-row
        v-if="skus.length"
        class="mb-1 font-weight-bold"
      >
        <b-col cols="4">
          Produk
        </b-col>
        <b-col cols="2">
          Varian
        </b-col>
        <b-col cols="2">
          Stok saat ini
        </b-col>
        <b-col cols="2">
          Tambah stok
        </b-col>
        <b-col cols="2">
          Stok baru
        </b-col>
      </b-form-row>
    </div>

    <b-form
      ref="formTable"
      @submit.prevent="submit"
    >
      <button
        ref="formButton"
        type="submit"
        hidden
      />
      <div
        v-if="skus.length"
        class="product-body"
      >
        <div
          v-for="(item, index) in skus"
          :key="`sku-${item.barcode}`"
          class="product-row py-75 px-50"
        >
          <b-form-row>
            <b-col
              md="4"
            >
              <b-form-row class="align-items-start">
                <b-col cols="1">
                  {{ index + 1 }}.
                </b-col>
                <b-col cols="auto">
                  <b-img
                    :src="linkStaging(item.product.images[0].image_url, 100, 100)"
                    :alt="item.name"
                    rounded
                    class="mr-50"
                    width="50px"
                  />
                </b-col>
                <b-col>
                  {{ item.product.name }}
                </b-col>
              </b-form-row>

            </b-col>

            <b-col
              cols="2"
            >
              <div v-if="item.variant">
                {{ item.variant }}
              </div>
              <div v-else>
                <i>Default</i>
              </div>
              <div class="text-muted mt-25">
                <small>{{ item.barcode }}</small>
              </div>
            </b-col>

            <b-col
              cols="2"
              class="d-flex align-items-center"
            >
              <b-form-input
                class="current-stock-input"
                type="number"
                :value="item.stock"
                readonly="readonly"
              />
              <feather-icon
                icon="PlusIcon"
                size="20"
                class="ml-75"
              />
            </b-col>

            <b-col
              cols="2"
              class="d-flex align-items-center"
            >
              <b-form-input
                v-model="item.add_stock"
                type="number"
                class="current-stock-input"
                required
                @keyup="changeAddStock(index)"
              />
              <span class="s-20 ml-75">=</span>
            </b-col>

            <b-col
              cols="2"
              class="d-flex align-items-center"
            >
              <b-form-input
                v-model="item.new_stock"
                class="current-stock-input"
                type="number"
                required
                min="0"
                @keyup="changNewStock(index)"
              />
              <b-button
                class="ml-2 btn-icon"
                variant="light"
                @click="remove(index)"
              >
                <feather-icon
                  icon="XIcon"
                  size="20"
                />
              </b-button>
            </b-col>
          </b-form-row>
        </div>
      </div>
    </b-form>

    <b-modal
      v-model="openResetConfirm"
      title="Apakah Anda yakin"
      ok-title="Ya, yakin"
      @ok="reset"
    >
      Daftar produk yang telah ditambahkan ke tabel akan hilang. Apakah Anda yakin?
    </b-modal>
  </b-card>
</template>

<script>
import {
  BSpinner,
  BFormCheckbox,
  BForm,
  BModal,
  BImg,
  BFormRow,
  BRow,
  BCol,
  BButton,
  BCard,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
} from 'bootstrap-vue'
import { mapActions, mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BForm,
    BFormCheckbox,
    BSpinner,
    BModal,
    BImg,
    BFormRow,
    BRow,
    BCol,
    BButton,
    BCard,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
  },
  data() {
    return {
      keyword: '',
      openResetConfirm: false,
      loadingSubmit: false,
    }
  },
  computed: {
    ...mapState('products', ['skus']),
  },
  mounted() {
    const skus = localStorage.getItem('skusStock')

    if (skus) {
      this.$store.commit('products/SET_SKUS', JSON.parse(skus))
    }
  },
  methods: {
    ...mapActions('products', ['getSkuByBarcode']),
    search() {
      if (this.skus.find(item => item.barcode === this.keyword)) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Produk sudah ditambahkan.',
            icon: 'BellIcon',
            variant: 'danger',
          },
        })

        return
      }

      this.getSkuByBarcode(this.keyword)
        .then(() => {
          localStorage.setItem('skusStock', JSON.stringify(this.skus))

          // reset
          this.keyword = ''
        })
    },
    reset() {
      localStorage.removeItem('skusStock')
      this.$store.commit('products/SET_SKUS', [])
    },
    submit() {
      const skus = this.skus.map(item => ({
        id: item.id,
        stock: item.new_stock,
      }))

      this.loadingSubmit = true
      this.$http.post('/v1/admin/update-stock', { skus })
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })

          this.reset()
        })
        .finally(() => {
          this.loadingSubmit = false
        })
    },
    confirmReset() {
      if (this.skus.length <= 1) {
        this.reset()
      } else {
        this.openResetConfirm = true
      }
    },
    remove(index) {
      const skus = [...this.skus]
      skus.splice(index, 1)

      localStorage.setItem('skusStock', JSON.stringify(skus))
      this.$store.commit('products/SET_SKUS', skus)
    },
    changeAddStock(index) {
      const skus = [...this.skus]
      skus[index] = {
        ...skus[index],
        add_stock: parseInt(skus[index].add_stock, 10), // initial
        new_stock: parseInt(skus[index].add_stock, 10) + skus[index].stock, // initial
      }

      localStorage.setItem('skusStock', JSON.stringify(skus))
      this.$store.commit('products/SET_SKUS', skus)
    },
    changNewStock(index) {
      const skus = [...this.skus]
      skus[index] = {
        ...skus[index],
        add_stock: parseInt(skus[index].new_stock, 10) - skus[index].stock, // initial
        new_stock: parseInt(skus[index].new_stock, 10), // initial
      }

      localStorage.setItem('skusStock', JSON.stringify(skus))
      this.$store.commit('products/SET_SKUS', skus)
    },
  },
}
</script>

<style lang="scss" scoped>
.sku-order {
  width: 20px;
}

.product-row:nth-child(even) {
  background-color: #F8F8F8;
}

.product-body {
  min-height: 200px;
}

.s-20 {
  font-size: 20px;
}
</style>
